import { FeeStructureCreate } from './FeeStructureCreate';
import { FeeStructureEdit } from './FeeStructureEdit';
import { FeeStructureList } from './FeeStructureList';

export default {
    create: FeeStructureCreate,
    edit: FeeStructureEdit,
    list: FeeStructureList
}
